import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useMembros, useProjetos } from '../hooks/useProjetos';
import { cores } from '../styles/cores';
import { Avatar, EstadoVazio, Spinner } from '../components/UI';

export function Equipe() {
  const { usuario } = useAuth();
  const { projetos, carregando: carregandoProjetos } = useProjetos();

  // Coleta todos os UIDs dos projetos visíveis: dono + convidados aceitos
  const uids = useMemo(() => {
    const conjunto = new Set();
    if (usuario?.uid) conjunto.add(usuario.uid);
    projetos.forEach((p) => {
      if (p.ownerUid) conjunto.add(p.ownerUid);
      (p.membroUids || []).forEach((uid) => conjunto.add(uid));
    });
    return [...conjunto];
  }, [projetos, usuario?.uid]);

  const membros = useMembros(uids);

  if (carregandoProjetos) return <Spinner />;

  return (
    <div>
      <h1 style={{ margin: '0 0 4px', fontSize: 22, color: cores.texto }}>Equipe</h1>
      <p style={{ margin: '0 0 24px', fontSize: 14, color: cores.textoSecundario }}>
        Colaboradores que participam dos seus projetos
      </p>

      {membros.length === 0 ? (
        <EstadoVazio
          titulo="Nenhum colaborador ainda"
          descricao="Convide pessoas para seus projetos. Elas aparecerão aqui após aceitar o convite."
        />
      ) : (
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
            gap: 16,
          }}
        >
          {membros.map((membro) => {
            const ehVoce = membro.uid === usuario?.uid;
            return (
              <div
                key={membro.uid}
                style={{
                  backgroundColor: '#fff',
                  border: `1px solid ${cores.card}`,
                  borderRadius: 12,
                  padding: 20,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  gap: 8,
                }}
              >
                <Avatar nome={membro.nome || membro.email} size={64} />
                <div style={{ fontWeight: 700, fontSize: 15, color: cores.texto }}>
                  {membro.nome}
                  {ehVoce && (
                    <span style={{ fontSize: 11, color: cores.textoSecundario, fontWeight: 400, marginLeft: 6 }}>
                      (você)
                    </span>
                  )}
                </div>
                <div style={{ fontSize: 13, color: cores.textoSecundario }}>{membro.email}</div>
                {membro.cargo && (
                  <span
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: cores.primario,
                      backgroundColor: cores.card,
                      padding: '4px 10px',
                      borderRadius: 999,
                    }}
                  >
                    {membro.cargo}
                  </span>
                )}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    fontSize: 12,
                    color: membro.ativo ? cores.sucesso : cores.textoSecundario,
                    marginTop: 4,
                  }}
                >
                  <span
                    style={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      backgroundColor: membro.ativo ? cores.sucesso : cores.textoTerciario,
                    }}
                  />
                  {membro.ativo ? 'Online' : 'Offline'}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
